/**
 * List of possible whitelabeled components.
 *
 * The keys are referenced in the <whitelabel>.config.ts
 */
export enum WhitelabeledComponentKey {
  APP_SWITCHER = 'APP_SWITCHER',
  USER_SETTINGS_MENU = 'USER_SETTINGS_MENU',
  TOPBAR_PLACEHOLDER = 'TOPBAR_PLACEHOLDER',
  SIDEBAR_MENU = 'SIDEBAR_MENU',
}

/**
 * List of props for whitelabeled components.
 *
 * The keys are referenced in the whitelabeled component.
 * Define the properties in a key => type list here, like {foo: string, bar: boolean}
 */
export type WhitelabeledComponentProps = {
  [WhitelabeledComponentKey.APP_SWITCHER]: unknown;
  [WhitelabeledComponentKey.USER_SETTINGS_MENU]: unknown;
  [WhitelabeledComponentKey.TOPBAR_PLACEHOLDER]: unknown;
  [WhitelabeledComponentKey.SIDEBAR_MENU]: unknown;
};
